<template>
    <div class="body">
        <el-row :gutter="20">
            <el-col :span="6">
                <div>
                    <el-statistic title="近三天发布的比赛">
                        <template slot="formatter">
                            {{ list1.length }} 个
                            <div style="margin-top: 10px;" v-for="item in list1" :key="item.id">{{ item.title }}</div>
                        </template>
                    </el-statistic>
                    <div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <div>
                    <el-statistic title="近一周发布的竞赛">
                        <template slot="formatter">
                            {{ list2.length }} 个
                            <div style="margin-top: 10px;" v-for="item in list2" :key="item.id">{{ item.title }}</div>
                        </template>
                    </el-statistic>
                </div>
            </el-col>
            <el-col :span="6">
                <div>
                    <el-statistic title="近一个月发布的竞赛">
                        <template slot="formatter">
                            {{ list3.length }} 个
                            <div style="margin-top: 10px;" v-for="item in list3" :key="item.id">{{ item.title }}</div>
                        </template>
                    </el-statistic>
                </div>
            </el-col>
            <el-col :span="6">
                <div>
                    <el-statistic title="近三个月发布的竞赛">
                        <template slot="formatter">
                            {{ list4.length }} 个
                            <div style="margin-top: 10px;" v-for="item in list4" :key="item.id">{{ item.title }}</div>
                        </template>
                    </el-statistic>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    import Url from '@/constant/Url'
    import $ from 'jquery'
    export default {
        name:'CountCompete',
        data() {
            return {
                list1:[],
                list2:[],
                list3:[],
                list4:[],
            }
        },
        mounted() {
            this.CountCompete()
        },
        methods: {
            CountCompete() {
                const vue = this
                const store = this.$store

                $.ajax({
                    url: Url.CountCompeteUrl,
                    type:'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            if (resp.list1 !== null) vue.list1 = JSON.parse(resp.list1)
                            if (resp.list2 !== null) vue.list2 = JSON.parse(resp.list2)
                            if (resp.list3 !== null) vue.list3 = JSON.parse(resp.list3)
                            if (resp.list4 !== null) vue.list4 = JSON.parse(resp.list4)
                        }
                    }
                })
            }
        }
    }
</script>

<style scoped>
.body {
    width: 1170px;
    min-height:50px;
    height: auto;
    margin:0 auto;
    background-color: white;
    padding: 20.8px;
    border-radius: 5px;
    box-sizing: border-box;
    border:2px solid lightgrey;
}
</style>